import "../sentryInstrumentReact";
import React from 'react';
import ReactDOM from 'react-dom/client';

import ShoppingCart from './ShoppingCart';
import { CartProvider } from './CartContext';
import StoreSearch from "./StoreSearch";

const cartDiv = document.getElementById('cart');
if (cartDiv !== null) {
  const selectDiv = ReactDOM.createRoot(cartDiv);
  selectDiv.render(
    <>
      <CartProvider>
        {/* <StoreSearch /> */}
        <ShoppingCart />
      </CartProvider>
    </>
  );  
}
